import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import { _ } from '/@/locale';
import { setReceiveNotifications } from '/@/store/session/actions';
import styles from './styles.module.css';

const ReceiveNotificationMessages = () => {
    const dispatch = useDispatch();
    const handleClick = (response: boolean) => {
        return () => dispatch(setReceiveNotifications(response));
    };
    return (
        <div className={styles.root}>
            <div>{_('Acepto recibir emails y mensajes de la app')}.</div>
            <div className={styles.actions}>
                <Button variant='contained' onClick={() => handleClick(true)}>
                    {_('Aceptar')}
                </Button>
                <Button variant='outlined' onClick={() => handleClick(false)}>
                    {_('Rechazar')}
                </Button>
            </div>
        </div>
    );
};

export default ReceiveNotificationMessages;
